import { IRootState, RootState } from '../root-state.store';
// @ts-ignore
import { IHomeService } from '@/services';
// @ts-ignore
import { ActivityStatus } from '@/common/enums';
import { HomeService } from '../../services';
import { 
  IHomeMemberStatisticListingViewModel,
  IHomeTicketStatisticListingViewModel,
  IHomeBlockStatisticListingViewModel,
  IHomeContractorStatisticListingViewModel,
  IHomeServiceBookStatisticViewModel
} from '../../models/home';

export interface IHomeState extends IRootState<IHomeService> {
  memberStatistic?: {
    activityStatus: ActivityStatus,
    data: IHomeMemberStatisticListingViewModel
  }
  ticketStatistic?: {
    activityStatus: ActivityStatus,
    data: IHomeTicketStatisticListingViewModel
  }
  blockStatistic?: {
    activityStatus: ActivityStatus,
    data: IHomeBlockStatisticListingViewModel
  }
  contractorStatistic?: {
    activityStatus: ActivityStatus,
    data: IHomeContractorStatisticListingViewModel
  }
  serviceBookStatistic?:{
    activityStatus: ActivityStatus,
    data: IHomeServiceBookStatisticViewModel
  }
}

export class HomeState extends RootState implements IHomeState {
  /**
   *
   */
  memberStatistic: {
    activityStatus: ActivityStatus,
    data: IHomeMemberStatisticListingViewModel
  }
  ticketStatistic: {
    activityStatus: ActivityStatus,
    data: IHomeTicketStatisticListingViewModel
  }
  blockStatistic: {
    activityStatus: ActivityStatus,
    data: IHomeBlockStatisticListingViewModel
  }
  contractorStatistic: {
    activityStatus: ActivityStatus,
    data: IHomeContractorStatisticListingViewModel
  }
  serviceBookStatistic: {
    activityStatus: ActivityStatus,
    data: IHomeServiceBookStatisticViewModel
  }
  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.service = new HomeService;
    this.memberStatistic = {
      activityStatus: ActivityStatus.NoActivity,
      data: {
        data: []
      }
    }
    this.ticketStatistic = {
      activityStatus: ActivityStatus.NoActivity,
      data: {
        chartsByDay: [],
        resolutionRate: null,
        averageResolutionTime: "0j 00h 00mn"
      }
    }
    this.blockStatistic = {
      activityStatus: ActivityStatus.NoActivity,
      data: {
        data: []
      }
    }
    this.contractorStatistic = {
      activityStatus: ActivityStatus.NoActivity,
      data: {
        data: []
      }
    }
    this.serviceBookStatistic = {
      activityStatus: ActivityStatus.NoActivity,
      data: {
        totalSbUsed: 0,
        totalSbFree: 0,
        totalSbExpired:0,
        totalDocument: 0
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/home/home-state.store.ts